import moment from 'moment';
import {NotificationInfo} from './notifications';
import {USER_ROLE} from '../constants/user';
import {t} from './i18nHandler';

export const getUserNameFromString = (string = '', fullName) => {
  const names = string.split('/');

  const firstName = names[0] ? names[0].trim() : '';
  const lastName = names[1] ? names[1].trim() : '';
  const middleName = names[2] ? names[2].trim() : '';

  if (fullName) return `${lastName} ${firstName} ${middleName}`.trim();

  return {
    firstName,
    lastName,
    middleName,
  };
};

export const getAddressFromString = (string = '', fullAddress) => {
  const addressArray = string.split('###');

  const index = addressArray[0] ? addressArray[0].trim() : '';
  const address = addressArray[1] ? addressArray[1].trim() : '';

  if (fullAddress) return `${index} ${address}`.trim();

  return {
    index,
    address,
  };
};

export const getRandomPassword = (length = 8) => {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let retVal = '';
  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
};

export const getExpireTokenDate = (dateTime) => {
  const time = new Date();
  return new Date(time.setSeconds(time.getSeconds() + dateTime || 3600));
};

export const copyUrl = (copyData, text = 'common.copyLink') => {
  const $body = document.getElementsByTagName('body')[0];
  const $tempInput = document.createElement('INPUT');
  $body.appendChild($tempInput);
  $tempInput.setAttribute('value', copyData);
  $tempInput.select();
  document.execCommand('copy');
  $body.removeChild($tempInput);
  NotificationInfo(t(text), null, 2000);
};

export const getRole = (role, localization) => {
  switch (role) {
  case USER_ROLE.CANDIDATE: return localization ? 'roles.candidate' : 'Кандидат';
  case USER_ROLE.EMPLOYER: return localization ? 'roles.employer' : 'Работодатель';
  case USER_ROLE.RECRUITER: return localization ? 'roles.recruitmentAgency' : 'Кадровое агентство';
  case USER_ROLE.ADMINISTRATOR: return localization ? 'roles.admin' : 'Администратор сайта';
  default: return '';
  }
};

export const getRandomId = () => Math.floor(Math.random() * 100000000).toString();

export const getHMS = (secs) => {
  const secNum = parseInt(secs, 10);
  let hours = Math.floor(secNum / 3600);
  let minutes = Math.floor(secNum / 60);
  let sec = secNum - (minutes * 60);
  if (hours < 10) {
    hours = `0${hours}`;
  }
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  if (sec < 10) {
    sec = `0${sec}`;
  }
  return {h: hours, m: minutes, s: sec};
};

export const getMS = (secs) => {
  const secNum = parseInt(secs, 10);
  let minutes = Math.floor(secNum / 60);
  let sec = secNum - (minutes * 60);
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  if (sec < 10) {
    sec = `0${sec}`;
  }
  return {m: minutes, s: sec};
};

export function pad(num, size) {
  return (`000${num}`).slice(size * -1);
}

export const timePad = (sec) => {
  const time = parseFloat(sec).toFixed(3);
  const hours = Math.floor(time / 60 / 60);
  const minutes = Math.floor(time / 60) % 60;
  const seconds = Math.floor(time - minutes * 60);

  return `${pad(hours, 2)}:${pad(minutes, 2)}:${pad(seconds, 2)}`;
};

export const autoResizeFiled = (value, field) => {
  if (value && field) {
    setTimeout(() => {
      field.style.cssText = 'height:auto;';
      field.style.cssText = `height:${field.scrollHeight}px`;
    }, 0);
  } else if (field && !value) {
    field.style.cssText = 'height:auto;';
  }
};

export const encode = (data) => {
  const string = JSON.stringify(data);
  return window.btoa(unescape(encodeURIComponent(string)));
};

export const decode = (string) => {
  const stringData = decodeURIComponent(escape(window.atob(string)));
  return JSON.parse(stringData);
};

export function formatDate(date, format = 'DD.MM.YYYY, HH:mm') {
  return moment(date).format(format);
}

export function isAvailableDate(date) {
  return moment().diff(date, 'minutes') < 0;
}

export function formatText(text = '') {
  return text.replace(/\r\n|\r|\n/g, '<br />');
}

export function getPeriodName(period) {
  if (!period) {
    return null;
  }
  switch (period) {
  case 1: return 'месяц';
  case 3: return 'три месяца';
  case 6: return 'полгода';
  case 12: return 'год';
  default: return `${period} месяцев`;
  }
}

export const onlyNumbers = /^[0-9.,]+$/;

export const secondsToMS = (seconds) => (moment.utc(moment.duration(seconds, 'seconds')
  .asMilliseconds()).format('mm:ss'));
